export const addoptimisers = (optimisers) => {
    return {    type: 'ADDOPTIMISERS',
                payload: optimisers 
            }
}

export const addpanels = (panels) => {
    return {    type: 'ADDPANELS',
                payload: panels 
            }
}

export const setselectedpanel = () => {
    return {type: 'SETSELECTEDPANEL'}

}

export const initpanels = (panelArray) => {
    return {type: 'INITPANELS', payload: panelArray}

}

export const setdontupdateallpanels  = () => {
    return {type: 'SETDONTUPDATEALLPANELS'}
}

export const addpaneltoarray  = (numpanels) => {
    return {type: 'ADDTOARRAY', payload: numpanels}
}

export const removefromarray  = (arrnum) => {
    return {type: 'REMOVEFROMARRAY', payload: arrnum }
}
export const updatepanelarray  = () => {
    return {type: 'UPDATEPANELARRAY'}
}
export const updatenumpanels  = () => {
    return {type: 'UPDATENUMPANELS'}
}
export const updatepaneldescription  = () => {
    return {type: 'UPDATEPANELDESCRIPTION'}
}

export const updatepanelorientation  = () => {
    return {type: 'UPDATEPANELORIENTATION'}
}

export const updatepanelroofpitch  = () => {
    return {type: 'UPDATEPANELROOFPITCH'}
}

export const  updatepanelshading = () => {
    return {type: 'UPDATEPANELSHADING'}
}

export const  updatebirdprotection = () => {
    return {type: 'UPDATEBIRDPROTECTION'}
}

export const   updatepanelinstallationlocation = () => {
    return {type: 'UPDATEPANELINSTALLATIONLOCATION'}
}


export const   updateoptimisers = () => {
            return {type: 'UPDATEOPTIMISERS'}
}

export const   updateoffgridsystem = (checked) => {
    return {type: 'SETOFFGRIDSYSTEM', payload: checked}
}

/*
export const   = () => {
    return {type: '', payload: }
}

*/
export const  updateelectric_estimated = (status) => {
    return {type: 'SETELECTRIC_ESTIMATED', payload: status }
}

export const  updateelecrate = (rate) => {
    return {type: 'SETELECRATE', payload: rate}
}

export const updatelistedproperty = (ptype) => {
    return {type: 'SETLISTEDPROPERTY', payload: ptype}
}

export const updateconservationarea = (ctype) => {
    return {type: 'SETCONSERVATIONAREA', payload: ctype}
}

export const updatedeposit = (deposit_amount) => {
    return {type: 'UPDATEDEPOSIT', payload: deposit_amount}
}

export const updaterepcustomermsg = (msg) => {
    return {type: 'UPDATEREPCUSTOMERMSG', payload: typeof msg!== "undefined" ? msg : ""}
}

export const updatesaveredux = () => {
    return {type: 'SAVEREDUX'}
}

export const updatecustomer2name = (name) => {
    return {type: 'UPDATECUST2NAME', payload: name}
}

export const updatecustomer2surname = (surname) => {
    return {type: 'UPDATECUST2SURNAME', payload: surname}
}

export const updatecustomer2title = (title) => {
    return {type: 'UPDATECUST2TITLE', payload: title}
}

export const updatecustomer2email = (email) => {
    return {type: 'UPDATECUST2EMAIL', payload: email}
}

export const  birdprotectionconfirmed = (checked) => {
    return {type: 'UPDATEBPCONFIRMSEND', payload: checked }
}

export const  agreementcheckconfirmed = (checked) => {
    return {type: 'UPDATEAGREEMENTCONFIRMSEND', payload: checked }
}

export const  updatefinmonthlypayment = (checked) => {
    return {type: 'UPDATEDFINMONTHLYPAYMENTS', payload: checked }
}


export const  updatefintotalcost = (checked) => {
    return {type: 'UPDATEDFINTOTALCOST', payload: checked }
}

export const  updateagreementdata = (checked) => {
    return {type: 'UPDATEAGREEMENTDATA', payload: checked }
}

export const updatempan = (mpan_number) => {
    return {type: 'UPDATEMPAN', payload: mpan_number}
}

export const updatenoratedisclaimer= (noratedisclaimer) => {
    return {type: 'UPDATENORATEDISCLAIMER', payload: noratedisclaimer}
}

export const updatepropertytype = (propertytype) => {
    return {type: 'UPDATEPROPERTYTYPE', payload: propertytype}
}

export const updateselectedsite = (site_id) => {
    return {type: 'UPDATESELECTEDSITE', payload: site_id}
}

// Panel Layout Sets Actions
export const updateLayoutSets = (arrayIndex, layoutSets) => {
    return {type: 'UPDATE_LAYOUT_SETS', payload: { arrayIndex, layoutSets }}
}

